/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   getBoxFromHoodOrCity
 */

import { boxToQueryBounds } from '@zcode/nr-utils'

const getBoxFromHoodOrCity = (opt, opt2) => {
  if (opt && opt.box) {
    return boxToQueryBounds(opt.box)
  } else if (opt2 && opt2.box) {
    return boxToQueryBounds(opt2.box)
  }
  return undefined
}

export default getBoxFromHoodOrCity
